<template>
  <CCardBody>
    <ul class="py-1">
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold">{{ $t(`manageBalance.planSummary.subTotal`) }}</span>
        <span class="text-gray-600">{{ subtotal }} €</span>
      </li>
      <li class="d-flex justify-content-between">
        <span class="text-gray-800 font-weight-bold"
          >{{ $t(`manageBalance.planSummary.tax`) }}
          <CButton
            v-c-tooltip.hover="{
              content: `Placement`,
              placement: 'right-end',
            }"
            class="p-0 m-0"
          >
            <CIcon name="question" size="custom-size" :height="15" viewBox="0 0 32 32" class="mr-3" />
          </CButton>
        </span>
        <span class="text-gray-600">{{ tax ? tax : $t(`manageBalance.planSummary.taxMayApply`) }} €</span>
      </li>
    </ul>
  </CCardBody>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CardSubTotal',
  props: {
    tax: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      placements: ['right-start', 'right', 'right-end', 'left-start', 'left', 'left-end'],
    }
  },

  computed: {
    isSummary() {
      return this.place == 'summary'
    },

    cartPackges() {
      return this.$store.state.balance.steps.cartPackges
    },

    subtotal() {
      var count = 0
      this.cartPackges.forEach(pack => count = count + (pack.package.packSelected.price * pack.quantity))
      return count
    },
    period() {
      return this.$store.state.backOffice.steps.paymentPeriod
    },

    ...mapGetters({
      lang: 'getLang',
    }),
  },

  methods: {
    applyDiscount(value) {
      if (this.period == 3) {
        let discount = value * 0.1
        let newValue = value - discount
        return newValue.toFixed(1)
      }

      return value
    },
  },
}
</script>

<style lang="scss">
.tooltip-old-inner {
  background: #fff;
  color: #000;
  border: 1px solid #ccc;
}
.bs-tooltip-old-auto[x-placement^='right'] .arrow:before,
.bs-tooltip-old-right .arrow:before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #fff;
}
</style>
